module.exports = __webpack_public_path__ + "static/3xmaisnutricao-logo-117736e6bec1771ade45376bc16bd3b7.svg";